import _ from 'lodash'

const getDefaultState = (key) => {
  const state = {
    isLoading: false,
    orderDateRange: [null, null],
    orderSearchText: '',
    orderContactMethod: '',
    orderStatus: 'OPEN',
    orderStockId: null,
    orderFilter: {
      pos: undefined,
      preorder: undefined,
      taxable: undefined,
      resellerId: undefined,
      contactMethods: [],
      shippingTypes: [],
      shippop: undefined,
      customerTags: [],
      productId: undefined
    },
    orderSelected: [],
    orderSortBy: 'id_DESC',
    expenseOrderSelected: null,
    defectiveProductSelected: []
  }
  return state[key] || state
}
const state = getDefaultState()

const mutations = {
  SET_LOADING (state, payload) {
    state.isLoading = payload
  },
  SET_ORDER_DATERANGE (state, payload) {
    state.orderDateRange = payload
  },
  SET_ORDER_SEARCHTEXT (state, payload) {
    state.orderSearchText = payload
  },
  SET_ORDER_CONTACTMETHOD (state, payload) {
    state.orderContactMethod = payload
  },
  SET_ORDER_STATUS (state, payload) {
    state.orderStatus = payload
  },
  SET_ORDER_STOCKID (state, payload) {
    state.orderStockId = payload
  },
  SET_ORDER_SELECTED (state, payload) {
    state.orderSelected = payload
  },
  SET_ORDER_SORTBY (state, payload) {
    state.orderSortBy = payload
  },
  SET_EXPENSEORDER_SELECTED (state, payload) {
    state.expenseOrderSelected = payload
  },
  SET_DEFECTIVEPRODUCT_SELECTED (state, payload) {
    state.defectiveProductSelected = payload
  },
  SET_ORDERFILTER (state, payload) {
    state.orderFilter = _.defaults(payload, state.orderFilter)
  }
}

const actions = {
  setLoading ({ commit }, payload) {
    commit('SET_LOADING', payload)
  },
  setOrderDateRange ({ commit }, payload) {
    commit('SET_ORDER_DATERANGE', payload)
  },
  setOrderSearchText ({ commit }, payload) {
    commit('SET_ORDER_SEARCHTEXT', payload)
  },
  setOrderContactMethod ({ commit }, payload) {
    commit('SET_ORDER_CONTACTMETHOD', payload)
  },
  setOrderStatus ({ commit }, payload) {
    commit('SET_ORDER_STATUS', payload)
  },
  setOrderStockId ({ commit }, payload) {
    commit('SET_ORDER_STOCKID', payload)
  },
  setOrderSelected ({ commit }, payload) {
    commit('SET_ORDER_SELECTED', payload)
  },
  setOrderSortBy ({ commit }, payload) {
    commit('SET_ORDER_SORTBY', payload)
  },
  setExpenseOrderSelected ({ commit }, payload) {
    commit('SET_EXPENSEORDER_SELECTED', payload)
  },
  setDefectiveProductSelected ({ commit }, payload) {
    commit('SET_DEFECTIVEPRODUCT_SELECTED', payload)
  },
  setOrderFilterPOS ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      pos: payload
    })
  },
  setOrderFilterPreorder ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      preorder: payload
    })
  },
  setOrderFilterTaxable ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      taxable: payload
    })
  },
  setOrderFilterResellerId ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      resellerId: payload
    })
  },
  setOrderFilterContactMethods ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      contactMethods: payload
    })
  },
  setOrderFilterShippingTypes ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      shippingTypes: payload
    })
  },
  setOrderFilterShippop ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      shippop: payload
    })
  },
  setOrderFilterCustomerTags ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      customerTags: payload
    })
  },
  setOrderFilterProductId ({ commit }, payload) {
    commit('SET_ORDERFILTER', {
      productId: payload
    })
  },
  clearOrderFilter ({ commit }) {
    commit('SET_ORDERFILTER', {
      pos: null,
      preorder: null,
      taxable: null,
      resellerId: null,
      contactMethods: [],
      shippingTypes: [],
      shippop: null,
      customerTags: [],
      productId: null
    })
  }
}

const getters = {
  isLoading: (state) => state.isLoading,
  orderDateRange: (state) => state.orderDateRange,
  orderSearchText: (state) => state.orderSearchText,
  orderContactMethod: (state) => state.orderContactMethod,
  orderStatus: (state) => state.orderStatus,
  orderStockId: (state) => state.orderStockId,
  orderSelected: (state) => state.orderSelected,
  orderSortBy: (state) => state.orderSortBy,
  expenseOrderSelected: (state) => state.expenseOrderSelected,
  defectiveProductSelected: (state) => state.defectiveProductSelected,
  orderFilter: (state) => state.orderFilter,
  variableOrderFilter: (state) => {
    let shippop
    if (state.orderFilter.shippop === 1) {
      shippop = false
    } else if (state.orderFilter.shippop === 2) {
      shippop = true
    }
    let startDate
    if (state.orderDateRange[0]) {
      startDate = state.orderDateRange[0]
    }
    let endDate
    if (state.orderDateRange[1]) {
      endDate = state.orderDateRange[1]
    }
    let taxable
    if (state.orderFilter.taxable) {
      taxable = true
    }
    return {
      stockId: state.orderStockId,
      search: state.orderSearchText,
      filter: state.orderStatus,
      contactMethod: state.orderContactMethod,
      startDate,
      endDate,
      taxable,
      shippop
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
